import { ChartColumn, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { Skeleton } from '../../../shared/components/Skeleton';
import { SkeletonRegion } from '../../../shared/components/SkeletonRegion';
import { useReportSummaries } from '../hooks/use-report-summaries';
import { reportTabPath } from '../reports.paths';

/** Every registered report. A small fixed catalogue (the release's reports), so it is fetched whole rather than paged. */
export function ReportsPage() {
  const state = useReportSummaries();
  if (state.status === 'error') throw state.error;

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('reports')}
        title="Reports"
        description="Figures across the business. Every figure opens the records behind it, and every report exports to Excel."
      />
      {state.status === 'forbidden' && <EmptyState icon={ShieldAlert} title="Not allowed" description="You don't have access to reports." />}
      {state.status === 'loading' && (
        <SkeletonRegion label="Loading reports" className="grid gap-4 md:grid-cols-2">
          <Skeleton className="h-28 w-full" />
          <Skeleton className="h-28 w-full" />
        </SkeletonRegion>
      )}
      {state.status === 'loaded' && state.reports.length === 0 && (
        <EmptyState icon={ChartColumn} title="No reports yet" description="No reports are available in this release." />
      )}
      {state.status === 'loaded' && state.reports.length > 0 && (
        <ul className="grid gap-4 md:grid-cols-2">
          {state.reports.map((report) => (
            <li key={report.key}>
              <Link
                to={reportTabPath(report.key, 'figures')}
                className="block rounded-xl border border-line bg-surface p-5 transition-colors hover:border-primary/40"
              >
                <h2 className="text-base font-semibold text-fg">{report.title}</h2>
                <p className="mt-1.5 text-sm text-muted">{report.description}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
